import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import "./App.css";

import OTPreAuthLoginPage from "./components/OTPreAuthLoginPage";
import OTPreAuthorizationPage from "./components/OTPreAuthorizationPage";
import Notice from "./components/Notice/Notice";
import MyInformationPage from "./components/Manu/MyInformationPage";
import LeaveManagementPage from "./components/Leave/LeaveManagementPage";
import TaskManagementPage from "./components/task/TaskManagementPage";
import ServiceManagementPage from "./components/service/ServiceManagementPage";
import EmployeeManagementPage from "./components/employee/EmployeeManagementPage";
import Leadmanagementpage from "./components/lead/LeadManagementPage";
import ForgotPasswordPage from "./components/ForgotPasswordPage";
import ResetPasswordPage from "./components/ResetPasswordPage";

interface Props extends PropsFromRedux { }

class App extends React.Component<Props> {
  componentDidMount() {
    const { app } = this.props;

    if (app && app.appTitle) {
      document.title = app.appTitle;
    }

  }

  // Function to check if user is authenticated
  isAuthenticated = (): boolean => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("userData");
    const userName = localStorage.getItem("userName");


    // Check if token and either userData or userName exists
    const isAuth = !!(token && (userData || userName));
    return isAuth;
  };

  // Function to check if menus are loaded
  hasMenusLoaded = (): boolean => {
    const menuItems = localStorage.getItem("menuItems");

    // Try to parse menuItems to verify it's valid JSON
    if (menuItems) {
      try {
        const parsed = JSON.parse(menuItems);
        const isValid = Array.isArray(parsed) && parsed.length > 0;
        return isValid;
      } catch (e) {
        console.error("📋 Menu check - invalid JSON:", e);
        return false;
      }
    }

    return false;
  };

  render() {
    const { app } = this.props;

    if (!app) {
      return null;
    }

    const authenticated = this.isAuthenticated();
    const menusLoaded = this.hasMenusLoaded();

    return (
      <div className="App">
        <Backdrop
          open={app.isShowBackdrop || false}
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<OTPreAuthLoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/authorize"
            element={
              authenticated ? (
                menusLoaded ? (
                  <OTPreAuthorizationPage />
                ) : (
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    background: 'linear-gradient(145deg,#04111a 0%,#091e2e 35%,#0d2840 60%,#06141e 100%)',
                    color: '#00d2c8'
                  }}>
                    <CircularProgress sx={{ color: '#00d2c8' }} />
                    <span style={{ marginLeft: '16px', marginTop: '16px', fontFamily: "'DM Sans', sans-serif" }}>
                      Loading menus...
                    </span>
                    <span style={{ marginTop: '8px', fontSize: '12px', color: '#7ab0b8' }}>
                      Please wait while we load your dashboard
                    </span>
                  </div>
                )
              ) : (
                <Navigate to="/login" replace />
              )
            }
          >
            <Route path="notice" element={<Notice />} />
            <Route path="profile" element={<MyInformationPage />} />
            <Route path="leave" element={<LeaveManagementPage />} />
            <Route path="tasks" element={<TaskManagementPage />} />
            <Route path="employee" element={<EmployeeManagementPage />} />
            <Route path="service" element={<ServiceManagementPage />} />
            <Route path="lead" element={<Leadmanagementpage />} />
            <Route index element={<Navigate to="notice" replace />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  app: state?.app || {},
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(App);